import React from "react";
import FusionCharts from "fusioncharts";
import TimeSeries from "fusioncharts/fusioncharts.timeseries";
import ReactFC from "react-fusioncharts";
import { isEqual } from "lodash";

ReactFC.fcRoot(FusionCharts, TimeSeries);
const FusionChart = ({ timeseriesDs }) => {
  return (
    <div>
      {timeseriesDs.dataSource.data ? <ReactFC {...timeseriesDs} /> : "loading"}
    </div>
  );
};

export default React.memo(FusionChart, isEqual);
